import { render, staticRenderFns } from "./Biao.vue?vue&type=template&id=30cc700f&scoped=true&"
import script from "./Biao.vue?vue&type=script&lang=js&"
export * from "./Biao.vue?vue&type=script&lang=js&"
import style0 from "./Biao.vue?vue&type=style&index=0&id=30cc700f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc700f",
  null
  
)

export default component.exports